const userState = {
    allUserRoles: undefined,
    email: undefined,
    last_login: undefined,
    manage_auth_connections: false,
    manage_kex: false,
    manage_map_features: false,
    manage_networking: false,
    manage_roles: false,
    manage_users: false,
    picture: undefined,
    positionError: undefined,
    requestingCurrentUser: false,
    requestingUserLocation: false,
    set_device: undefined,
    userLocation: undefined
};
export default userState;
